import { useCallback, useState } from "react";

export const useCollapse = (initialState = true) => {
  const [isCollapse, setIsCollapse] = useState(initialState);
  const toggleCollapse = useCallback(() => setIsCollapse((prev) => !prev), []);
  const collapse = useCallback(() => setIsCollapse(true), []);
  const expand = useCallback(() => setIsCollapse(false), []);

  return { isCollapse, toggleCollapse, collapse, expand };
};
